import {
  Component, EventEmitter, HostBinding, Input, OnChanges, Output, SimpleChanges,
} from '@angular/core';
import { elementAt } from 'rxjs';
import { AbstractFilterElementComponent, FilterEmitterType } from './abstract-filter-element.component';
import { FilterElementSize, gridClassesForFilterElementSize } from './filter-elements';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { FloatLabelModule } from 'primeng/floatlabel';
import { FluidModule } from 'primeng/fluid';
import { InputTextModule } from 'primeng/inputtext';


@Component({
  selector: 'text-search-filter-element',
  templateUrl: './text-search-filter-element.component.html',
  imports: [
    FormsModule,
    TranslatePipe,
    FloatLabelModule,
    FluidModule,
    InputTextModule,
    ],
})
export class TextSearchFilterElementComponent extends AbstractFilterElementComponent implements OnChanges {
  @HostBinding('class')
  override componentClass = '';

  @Input()
  override size: FilterElementSize = FilterElementSize.MEDIUM;

  @Input()
  override label: string | undefined;

  @Input()
  override filterActive = false;

  @Input()
  override filterKey!: string;

  @Output()
  override filterTerm: EventEmitter<FilterEmitterType> = new EventEmitter();

  ngOnChanges(changes: SimpleChanges) {
    if (changes['size']) {
      this.componentClass = gridClassesForFilterElementSize(changes['size'].currentValue);
    }
    if (changes['filterActive']) {
      this.value = changes['filterActive'].currentValue ? this.value : null;
    }
  }

  override onFilterChange(changes: Event) {
    const inputElement = changes.target as HTMLInputElement;
    const value = inputElement.value.trim();
    this.filterTerm.emit({ key: this.filterKey, term: value ? `${this.filterKey}-${value}-and` : undefined });
  }

  protected readonly elementAt = elementAt;
}
